import { render, staticRenderFns } from "./BtnAtualizarEntrega.vue?vue&type=template&id=4eca36bc"
import script from "./BtnAtualizarEntrega.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarEntrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports